$(function(){
	var form = {
		requestSubmitModal: document.getElementById('requestSubmit-modal'),
		requestResultModal: document.getElementById('requestResult-modal'),
		el1: document.getElementById('addsAnnouncementsViewPopInfo1'),
		el2: document.getElementById('addsAnnouncementsViewPopInfo2'),
		submitBtn: document.getElementById('requestSubmit'),
		serialNumber: document.getElementById('txtSerialNumber'),
		addResultPopView: document.querySelector('.add-result-pop-view'),
		resultSubmitBtn: document.getElementById('requestResultSubmit'),
		init: function(){
			var allDateInputs = $(form.el2).find("input.datepicker-input");
			allDateInputs.datepicker( "option", "minDate", "+1D" );
			
			form.addEvent();	
			
			if(isMobile){
				$(".reservation-date").focus(function(){
					$(this).blur();
				});
			}
		},
		beforeSubmit: function(e){
			if($(form.serialNumber).checkValidation({trigger:true}) && $(form.el1).checkValidation({trigger:true}) && $(form.el2).checkValidation({trigger:true}) ){
				
				
				/* LGEGMC-4766 start */
				if( $("#useNewCaptcha").length > 0 && $("#useNewCaptcha").val() == "Y"){
					
					if( !!$('#siteKey').val() && $("#useNewCaptchaView").val() == "N"){
						var reCaptcha_Key = $('#siteKey').val();
						// LGEGMC-5323 start
			        	grecaptcha.enterprise.ready(function() {
			        		grecaptcha.enterprise.execute(reCaptcha_Key, {action: $("#recaptchaPageType").val()}).then(function(token) {
			        			$("#verifyKey").val(btoa(token));
			        			formAnSubmit();
			        		});
			        	});
			        	// LGEGMC-5323 end
					}else if( !!$('#verifyKey').val() && $("#useNewCaptchaView").val() == "Y"){
						formAnSubmit();
					}else{
						formAnSubmit();
					}
				}else{
					if( $(".captchaFlag_hidden").val() == "Y"){
						if(captcha.validation() != false) {
							formAnSubmit();
						}else {
							e.preventDefault();
						}
					}else{
						formAnSubmit();
					}
				}
				/* LGEGMC-4766 end */
				
				function formAnSubmit(){
					$(".serialNumber_hidden").val($(form.serialNumber).val());
					
					var url = $(form.el2).attr('data-action');
					var params = new FormData();
					form.addparam( params, $(form.el1).serializeArray() );
					form.addparam( params, $(form.el2).serializeArray() );
	
					$.ajax({
						url: url,
						type: 'post',
						data: xssfilter(params),
						async: false,
						dataType: 'json',
						enctype: 'multipart/form-data',
						processData: false,
						contentType: false,
						beforeSend: function() {
						
						},
						success: function(data) {
							if (data.result) {
								$(form.addResultPopView).find(".resultReceipNumber").text(data.submitData.caseNumber);
								$(form.addResultPopView).find(".resultReceipDate").text(data.submitData.receiptDate);
								$(form.addResultPopView).find(".resultPath").attr("src",data.submitData.path);
								$(form.addResultPopView).find(".resultModelName").text(data.sendData.customerModel);
								$(form.addResultPopView).find(".resultSerialNumber").text(data.sendData.serialNumber);
								$(form.addResultPopView).find(".resultCustomerName").text(data.submitData.customerName);
								$(form.addResultPopView).find(".resultEmail").text(data.sendData.emailAddress);
								$(form.addResultPopView).find(".resultTelephone").text(data.sendData.contactTelephone);
								$(form.addResultPopView).find(".resultMobilePhone").text(data.sendData.contactMobilePhone);
								if( data.sendData.contactZipCode.length > 0){
									$(form.addResultPopView).find(".resultAddress").text(data.sendData.contactZipCode+", "+data.sendData.contactStreet);
								}else{
									$(form.addResultPopView).find(".resultAddress").text(data.sendData.contactStreet);
								}
								$(form.addResultPopView).find(".resultReservationDate").text(data.sendData.resultDateDates01); 
								
								$(form.requestSubmitModal).modal('hide');
								$(form.requestResultModal).modal('show');
								
								form.reset();
								
							} else {
								// LGECS-190 start
								var $error;
								if( data.msg && data.msg == 'downTimeChk'){
									$error = $('#downTime-modal');
									$error.find('.downTime-body').html(data.guideSubText);
								}else{
									$error = $('#step_submit_error');
									
									if(data.msg && data.msg != '') {
										$error.find('.content-paragraph').text(data.msg);
									}else {
										$error.find('.content-paragraph').text($error.attr('data-default-msg'));
									}
								}
								
								$(form.requestSubmitModal).modal('hide');
								$error.modal('show');
								// LGECS-190 end
								
								// LGEGMC-4766 start
								if(document.getElementById('customizedCaptcha') ==  null || document.getElementById('customizedCaptcha') == undefined ){
									if( !!$('#verifyKey').val() && $("#useNewCaptchaView").val() == "Y"){
										reload_recaptcha_wrapper();
									}
								}
								// LGEGMC-4766 end
							}
						},
						error: function(request, status, error) {
							console.log(error);
						}
					});
				}
			}
		},
		addEvent: function(){
			if(document.querySelector('#btnCMS-Request')){
				$("#btnCMS-Request").on('click',function(e){
					// LGEDE-1071, LGEUK-896 Start
					if($("input[name=repairWarrantyPageUseFlag]").val() == "Y" ) {
						var popupForm = $("#announcementGoNewPageForm")
						$(popupForm).submit();
					} else {
						$('#requestSubmit-modal').modal('show');
					}
					// LGEDE-1071, LGEUK-896 End
				});
			}
			
			$(form.submitBtn).click(function(){
				form.beforeSubmit();
			});
			
			$(form.resultSubmitBtn).click(function(){
				$(form.requestResultModal).modal('hide');
			});
		},
		addparam: function( params, curParams){
			for (var i = 0; i < curParams.length; i++) {
				params.append(curParams[i].name, curParams[i].value);
			}
		},
		reset: function(){
			$(".search-common")[0].reset();
			$(form.serialNumber).val("");
			$(form.el1)[0].reset();
			$(form.el2)[0].reset();
			$("#customizedCaptcha_ReloadLink").click();
		}
	};
		
	form.init();
});